(() => {
  window.nnReady = true;   // the page script has started (the watchdog in <head> stands down)
  window.nnCore = true;    // the theme's header, menu and reveal run here (the prototype's page scripts skip theirs)
  // Neris ir Nemunas theme: what every page shares. Each part runs on its own (run), so a problem in one part never
  // stops the others or leaves the page hidden.
  const run = (name, part) => {
    (window.nnParts = window.nnParts || {})[`core:${name}`] = () => { try { part(); } catch (err) { console.error(`[core] ${name}:`, err); } };
    try { part(); } catch (err) { console.error(`[core] ${name}:`, err); }
  };
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Told once the page has scrolled past a height (and back), by the browser's own observer: nothing of ours runs on
  // each scrolled frame (2026-10-20: reading the scroll position on every scroll event made the owner's tablet redo
  // the page's styles on almost every frame).
  const past = (y, fn) => {
    if (!('IntersectionObserver' in window)) {
      const on = () => fn(window.scrollY > y);
      addEventListener('scroll', on, { passive: true });
      on();
      return;
    }
    const m = document.createElement('div');
    m.setAttribute('aria-hidden', 'true');
    m.style.cssText = `position:absolute;left:0;top:${y}px;width:1px;height:1px;pointer-events:none;visibility:hidden`;
    document.body.appendChild(m);
    let was = null;
    new IntersectionObserver(([e]) => {
      const now = !e.isIntersecting && e.boundingClientRect.top < 0;
      if (now !== was) { was = now; fn(now); }
    }).observe(m);
  };
  window.nnPast = past;

  run('reveal', () => {
    // Gentle reveal on scroll (the homepage's). The page hides .reveal blocks only while scripts run (the "js" class
    // is set in <head>). Without IntersectionObserver, with reduced motion, or if the observer stays silent,
    // everything shows at once; a block scrolled past too fast is shown too, so nothing waits hidden above.
    const items = [...document.querySelectorAll('.reveal:not(.is-in)')];
    const showAll = () => items.forEach((el) => el.classList.add('is-in'));
    if (!items.length) return;
    if (still || !('IntersectionObserver' in window)) { showAll(); return; }
    let heard = false;
    const io = new IntersectionObserver((entries) => {
      heard = true;
      entries.forEach((en) => {
        if (en.isIntersecting || en.boundingClientRect.bottom < 0) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach((el) => io.observe(el));
    setTimeout(() => { if (!heard) { io.disconnect(); showAll(); } }, 3000);
    let settle = 0;
    addEventListener('scroll', () => {
      clearTimeout(settle);
      settle = setTimeout(() => items.forEach((el) => {
        if (!el.classList.contains('is-in') && el.getBoundingClientRect().top < innerHeight * 0.92) {
          el.classList.add('is-in');
          io.unobserve(el);
        }
      }), 140);
    }, { passive: true });
  });

  // The folds (Apie laikrodį, Detalės, Dėžutėje…; 2026-10-21, the owner's recording: "when I open them things just move
  // around"): a fold glides open and shut instead of jumping, and the title pressed stays where it was under the finger
  // or the cursor, whatever opens or closes around it. Without scripts, or with reduced motion, they open as before.
  run('folds', () => {
    if (window.nnFoldsBound) return;
    window.nnFoldsBound = true;
    const MS = 320;
    const ease = 'cubic-bezier(.22,.61,.36,1)';
    document.addEventListener('click', (e) => {
      const sum = e.target.closest && e.target.closest('details.pd-fold > summary');
      if (!sum || e.defaultPrevented) return;
      const fold = sum.parentElement;
      const body = fold.querySelector(':scope > .pd-fold-body');
      if (!body || !body.animate) return;
      e.preventDefault();
      if (fold.dataset.moving) return;
      const top = sum.getBoundingClientRect().top;
      const hold = () => { const d = sum.getBoundingClientRect().top - top; if (Math.abs(d) > 0.5) scrollBy(0, d); };
      const opening = !fold.open;
      if (still) { fold.open = opening; hold(); return; }
      fold.dataset.moving = '1';
      if (opening) fold.open = true;
      const h = body.scrollHeight;
      body.style.overflow = 'hidden';
      body.style.boxSizing = 'border-box';           // its own padding inside the height that moves
      const a = body.animate(opening
        ? [{ height: '0px', opacity: 0 }, { height: `${h}px`, opacity: 1 }]
        : [{ height: `${h}px`, opacity: 1 }, { height: '0px', opacity: 0 }], { duration: MS, easing: ease });
      let on = true;
      const keep = () => { if (!on) return; hold(); requestAnimationFrame(keep); };
      requestAnimationFrame(keep);
      const done = () => {
        on = false;
        if (!opening) fold.open = false;
        body.style.overflow = '';
        body.style.boxSizing = '';
        delete fold.dataset.moving;
        hold();
      };
      a.onfinish = done;
      a.oncancel = done;
    });
  });

  run('scrolling', () => {
    // While the page scrolls, the drawings that move by themselves hold still (.is-scrolling on each of them: the
    // rivers' pulses, the wishing well; the moving words read window.nnScrolling), so a slower phone spends its frames
    // on the scroll (2026-10-20, the owner's tablet: the homepage at 30 frames a second, "super laggy"); they go on a
    // moment after it stops. Only those few elements change, never the whole page.
    const movers = [...document.querySelectorAll('[data-rv], [data-ideas]')];
    let t = 0;
    const set = (on) => {
      window.nnScrolling = on;
      movers.forEach((el) => el.classList.toggle('is-scrolling', on));
    };
    addEventListener('scroll', () => {
      if (!window.nnScrolling) set(true);
      clearTimeout(t);
      t = setTimeout(() => set(false), 180);
    }, { passive: true });
  });

  run('header', () => {
    // On the homepage the header lies over the first photo and turns solid once the page scrolls; on every other page
    // it is solid (data-solid). The top bar tucks away after the first screen.
    const header = document.querySelector('[data-header]');
    if (!header) return;
    const solid = header.hasAttribute('data-solid');
    if (!solid) past(40, (on) => header.classList.toggle('is-solid', on));
    past(120, (on) => header.classList.toggle('is-tucked', on));
  });

  run('menu', () => {
    // The phone menu. A link chosen in it closes it (a link to a place on the same page, too), a page brought back with
    // the browser's Back never comes back with it open, and Tab stays inside it while it is open.
    const drawer = document.querySelector('[data-drawer]');
    const openBtn = document.querySelector('[data-menu-open]');
    const closeBtn = document.querySelector('[data-menu-close]');
    if (!drawer || !openBtn || !closeBtn || drawer.dataset.nnBound) return;
    drawer.dataset.nnBound = '1';
    const isOpen = () => drawer.classList.contains('is-open');
    const setMenu = (open, focus = true) => {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', !open);
      openBtn.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
      if (focus) (open ? closeBtn : openBtn).focus({ preventScroll: true });
    };
    // The phone's Back closes the menu instead of leaving the page (2026-10-21, the owner): opening it adds a step to
    // the browser's history, Back takes that step and only closes the menu; closed any other way, the step is taken
    // back out; a page chosen in it takes the step's place, so Back from that page comes straight back here.
    let step = false;
    const open = () => {
      if (isOpen()) return;
      setMenu(true);
      try { history.pushState({ nnMenu: 1 }, ''); step = true; } catch (e) { /* a local file without history */ }
    };
    const close = (focus = true) => {
      setMenu(false, focus);
      if (step) { step = false; history.back(); }
    };
    addEventListener('popstate', () => { if (!step) return; step = false; if (isOpen()) setMenu(false); });
    openBtn.addEventListener('click', open);
    closeBtn.addEventListener('click', () => close());
    drawer.addEventListener('click', (e) => {
      const a = e.target.closest('a[href]');
      if (!a || !isOpen()) return;
      if (step && !e.defaultPrevented && e.button === 0 && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)
          && !a.target && !a.hasAttribute('download') && a.origin === location.origin) {
        e.preventDefault();
        step = false;
        setMenu(false, false);
        location.replace(a.href);
        return;
      }
      close(false);
    });
    addEventListener('pageshow', (e) => { if (!e.persisted) return; step = false; if (isOpen()) setMenu(false, false); });
    document.addEventListener('keydown', (e) => {
      if (!isOpen()) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      const f = [...drawer.querySelectorAll('a[href],button:not([disabled]),input,select,textarea')].filter((el) => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    });
  });

  run('photo ahead', () => {
    // A watch's card hovered or pressed: its product page's first photo is fetched at once, with the very sizes that page
    // asks for (nn-gallery: 800/1200/1600/2000 wide, 100vw on phones, 55vw beside the buying column), so the photo is in
    // the browser before the page opens and does not pop in after it (2026-10-29, the owner: things "load in like that",
    // "make the website faster"). Only a picture is fetched: no page runs, no ad event.
    const done = new Set();
    const ahead = (e) => {
      const a = e.target.closest && e.target.closest('a.card[href*="/products/"]');
      const img = a && a.querySelector('.card-media img');
      if (!img || done.has(a.href)) return;
      const src = img.currentSrc || img.src;
      if (!/[?&]width=\d+/.test(src)) return;
      done.add(a.href);
      const at = (w) => src.replace(/([?&]width=)\d+/, `$1${w}`);
      const pic = new Image();
      pic.sizes = '(max-width: 900px) 100vw, 55vw';
      pic.srcset = [800, 1200, 1600, 2000].map((w) => `${at(w)} ${w}w`).join(', ');
      pic.src = at(1600);
    };
    document.addEventListener('pointerover', ahead, { passive: true });
    document.addEventListener('touchstart', ahead, { passive: true });
  });

  run('cart count', () => {
    // The number on the bag: other scripts call nnCart.count(n) after adding to the cart; a page restored from the
    // browser's memory asks the cart again, so the number is never out of date.
    const badges = () => [...document.querySelectorAll('[data-cart-count]')];
    const show = (n) => badges().forEach((b) => { b.textContent = n; b.hidden = !n; });
    const refresh = () => fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart.js`, { headers: { Accept: 'application/json' } })
      .then((r) => r.json()).then((c) => show(c.item_count)).catch(() => {});
    window.nnCart = { count: show, refresh };
    addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });
  });
})();
